/**
 * Shared localStorage key constants used across lib and context layers.
 * Centralised here to avoid circular dependencies between them.
 */
export const PENDING_ACTIVE_ACCOUNT_KEY = 'mackinac:pendingActiveAccount'
export const AT_HANDLE_HISTORY_KEY = 'mackinac:at_handle_history'
export const GOTO_PROFILE_HISTORY_KEY = 'mackinac:goto_profile_history'
export const SEARCH_RECENTS_KEY_PREFIX = 'mackinac:search:recents:v2'
// v1 lists mixed accounts (#2442); swept whenever the Search recents hook mounts.
export const SEARCH_RECENTS_LEGACY_KEY_PREFIX = 'mackinac:search:recents:v1'
export const MASTODON_TAB_PREFS_KEY_PREFIX = 'mackinac:mastodonTabPrefs'
